<form #formAirportLocation="ngForm" id="confirmAddress" name="formAirportLocation"
  (submit)="handleSubmitLocation(formAirportLocation.value, formAirportLocation.valid, $event)" novalidate>

  <div class="form-group form-group-lg with-select">
    <!-- onfocus='this.size=10; this.style.height="100px"' onblur='this.size=0;this.style.height="auto"' -->
    <select onchange='this.size=1; this.blur();' class="form-control box-shadow"
      [ngClass]="{ 'has-error' : showNoAirportError }" id="airport" name="airport" [(ngModel)]="selectedAirportItem"
      (ngModelChange)="airportChanged($event)" appCheckEmpty required>
      <option value="" disabled></option>
      <option *ngFor="let airport of airportData.allowedTerminals; let i = index" [value]="i">{{
        airport.airportDropDownDisplayText }}</option>
    </select>

    <label class="control-label">{{appCopy.panelHeader['selectAirportLabel'+selectedLanguage]}}</label>
    <a *ngIf="terminalSelected" class="control-btn" (click)="clearInput()" href="javascript:void(0)">
      <i class="icon">cross</i>
    </a>
    <p class="help-block text-danger" *ngIf="showNoAirportError">
      {{appCopy.panelHeader['errorTextAirport'+selectedLanguage]}}</p>
  </div>

  <div class="form-group with-select fadeIn" *ngIf="showTerminalDropDown === 'true'">
    <select class="form-control" [ngClass]="{ 'has-error' : showNoTerminalError }" id="terminal" name="terminal"
      [(ngModel)]="selectedTerminalItem" (ngModelChange)="terminalChanged($event)" appCheckEmpty required>
      <option value="" disabled></option>
      <option *ngFor="let terminal of airportSelectedData.terminals; let i = index" [value]="i">{{
        terminal.terminalDisplayText }}</option>
    </select>
    <label class="control-label">{{appCopy.panelHeader['selectTerminalLabel'+selectedLanguage]}}</label>

    <p class="help-block text-danger" *ngIf="showNoTerminalError">
      {{appCopy.panelHeader['errorTextTerminal'+selectedLanguage]}}</p>
  </div>

  <div class="panel panel-default margin-bottom-16 fadeIn" *ngIf="terminalSelected">
    <div class="flex-lg flex-md flex--stretch">
      <div class="flex-always flex__item--equal">
        <div class="loader-container-img" *ngIf="!imgLoaded">
          <div class="loader loader--gray">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div>
        <img class="img-responsive" [src]="terminalImg" *ngIf="imgLoaded && !imgFail">
      </div>
      <div class="panel-body flex__item--equal">
        <h4 class="margin-top-0 margin-bottom-16">{{ airportLocation.airport }}</h4>
        <p class="text-muted margin-bottom-0">{{ terminalCopy }}</p>
      </div>
    </div>
  </div>

  <div class="alert alert-success">
    <h6 class="margin-top-0 margin-bottom-8">{{appCopy.panelHeader['lookingForAnotherAirport'+selectedLanguage]}}</h6>
    <p>{{appCopy.panelHeader['helperTextAirport'+selectedLanguage]}}</p>
  </div>

  <button id="formAirportLocation-submit" type="submit" class="btn btn-purple btn-block margin-top-32"
    [disabled]="isLoading">
    <div class="loader-container-btn" *ngIf="isLoading">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{appCopy.panelHeader['buttonContinue'+selectedLanguage]}}
  </button>

</form>